import {Box, Typography} from '@mui/material';
import React from 'react';

interface Props {
  number?: number;
  expandIfEmpty?: boolean;
  size?: 'default' | 'small';
}

const PlayerNumber: React.FC<Props> = ({number, expandIfEmpty, size}) => (
  <Box
    sx={{
      textAlign: expandIfEmpty ? 'left' : null,
      mr: expandIfEmpty ? null : 2,
      minWidth: expandIfEmpty ? (size === 'small' ? 50 : 80) : null,
    }}>
    {(number ?? 0) > 0 && (
      <Typography
        sx={{
          fontFamily: 'Orbitron',
          fontWeight: 700,
          fontSize: size === 'small' ? 24 : 40,
        }}>
        {number}
      </Typography>
    )}
  </Box>
);

export default PlayerNumber;
